export function updateFilterUrl(selectedFilters, currentPage){
    let filterUrl = '';
    let count = 0;
    let page = 0;

    selectedFilters.forEach((selected_filter) => {
        let filter_name = selected_filter.name,
            filter_values = [];

        if (selected_filter.name === "top_filter"){
            let all = true;
            selected_filter.elements.forEach((element) => {
                if (element.value){
                    filter_values.push(element.id);
                    all = false;
                }
            });
            if (all){
              selected_filter.elements.map((element) => {
                  if (element.id === "all"){
                    element.value = true;
                  }
              })
            }
        }
        else if (selected_filter.name === "date") {
            selected_filter.elements.forEach((element) => {
                if (element.value){
                    filter_values.push(element.value);
                }
            })
        }
        else if (selected_filter.name === "search"){
            selected_filter.elements.forEach((element) => {
                if (element.value.length){
                    filter_values.push(element.value);
                }
            })
        } else {
            selected_filter.elements.forEach((element) => {
                if (element.value){
                    filter_values.push(element.id);
                }
            })
        }
        if (filter_values.length){
            if (count > 0){
                filterUrl += '&';
            } else {
                filterUrl += '#';
            }
            filterUrl += filter_name + '=' + filter_values.toString();
            count += 1;
        }

    })

    if (count > 0){
      filterUrl += '&page=' + currentPage;

    } else {
      filterUrl += '#page=' + currentPage;
    }
    window.history.pushState(null, null, filterUrl);
  }


  export function parseFilterUrl(form){
    let hash =  window.location.hash;


    let data = {
      'form' : form,
      'page' : 1
    }

    if (!hash.length)
        return data;

    let params = hash.split("#")[1].split("&");

    params.forEach((param, i)=> {
        const v = param.split("=");
        if (v[0] === "page"){
          data.page = parseInt(v[1]);
        }
        else if (v[0] == "date") {
          let dates = v[1].split(",");
          data.form.map((form_section) => {
            if (form_section.name === v[0]){
              if (typeof dates[0] != "undefined"){
                form_section.elements[0].value = parseInt(dates[0]);
              }
              if (typeof dates[1] != "undefined"){
                form_section.elements[1].value = parseInt(dates[1]);
              }
            }
          })
        }
        else {
          data.form.map((form_section) => {
            if (form_section.name === v[0]){
                form_section.elements.map((element) => {
                    if (v[1].indexOf(element.id) > -1){
                        element.value = true;
                    }
                })
            }
          })
        }
    });




    return data;

  }
